module.exports = __webpack_public_path__ + "img/12-4.32c6e3ef.jpg";